// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__EzRop","icon":"styles_icon__2IKCo"};